import React from 'react';
import { Card } from 'cdk-radial';
import { IconChevronLeft, AvatarWrapper, Content } from 'cdk-radial';
import './SolutionHeader.scss';
import BackButton from '../../UI/BackButton/BackButton';

const SolutionHeader = (props) => {
    let orgInitials = '';
    if(props?.isAppNotListed)
    {
        let initials = props?.publisherName?.split(' ');
        initials.forEach((split) => {
            orgInitials  += split.charAt(0).toUpperCase();
        });
        orgInitials = orgInitials.substring(0, 2);
    }

    return (
        <div className="edit-dms-solution-info-card">
            <div className="edit-dms-solution-info-card-wrapper">
                <BackButton
                  icon={<IconChevronLeft />}
                  text={props.text || "Back to App Management"}
                  onLoadSubscriptionManagmentScreen={props.onBackButtonClickHandler}
                />
                <div className="edit-dms-solution-info-card-container">
                    <Card className={props?.isAppNotListed ? "solution-info-card-logo-unlisted-app" : "edit-dms-solution-info-card-logo"}>
                        {
                            props?.isAppNotListed ?
                              <AvatarWrapper className="org-logo-solution-header">
                                  <Content
                                    style={{
                                        color: 'white',
                                    }}
                                  >
                                      {orgInitials}
                                  </Content>
                              </AvatarWrapper>
                              :
                              <img
                                src={props?.solutionData?.overview?.solutionLogo}
                                alt="App Logo"
                                className="edit-dms-solution-icon"
                              />
                        }
                    </Card>
                    <div className="edit-dms-solution-info-card-app-data">
                        <div className="edit-dms-solution-info-card-app-name">{props?.solutionData?.overview?.name || props?.appName}</div>
                        <div className="edit-dms-solution-info-card-app-publisher">{props?.solutionData?.overview?.publisherName || props?.publisherName}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SolutionHeader;
